import React from 'react';
import { useCollection } from '../hooks/useCollection';
import { Link } from 'react-router-dom';
import { formatDistanceToNow } from 'date-fns';

const PostList = () => {
  const { documents: posts, isPending, error } = useCollection('posts', ['orderBy', 'createdAt', 'desc']);

  if (isPending) return <div className="text-center py-10">Loading posts...</div>;
  if (error) return <div className="text-center py-10 text-red-500">{error}</div>;

  return (
    <div className="space-y-6 sm:space-y-8">
      {posts && posts.length > 0 ? (
        posts.map(post => (
          <div key={post.id} className="bg-white p-4 sm:p-6 rounded-xl shadow-md border border-slate-200/80 transition hover:shadow-lg">
            <div className="flex flex-col sm:flex-row items-start sm:space-x-4">
                <img src={post.imageUrl} alt={post.title} className="w-full h-40 sm:w-32 sm:h-32 object-cover rounded-lg flex-shrink-0 mb-4 sm:mb-0"/>
                <div className="flex-1">
                    <p className="text-sm text-slate-500">By {post.author} &bull; {formatDistanceToNow(post.createdAt.toDate(), { addSuffix: true })}</p>
                    <h3 className="mt-1 text-lg sm:text-xl font-bold text-slate-800">
                        <Link to={`/posts/${post.id}`} className="hover:underline">
                            {post.title}
                        </Link>
                    </h3>
                    <p className="mt-2 text-slate-600 line-clamp-2 text-sm sm:text-base">{post.content}</p>
                    <Link to={`/posts/${post.id}`} className="text-blue-600 font-semibold hover:underline mt-3 sm:mt-4 inline-block text-sm sm:text-base">Read more &rarr;</Link>
                </div>
            </div>
          </div>
        ))
      ) : (
        <div className="text-center py-10 bg-white p-6 rounded-xl shadow-md border border-slate-200/80">
            <h3 className="text-xl font-semibold text-slate-700">No posts yet.</h3>
            <p className="text-slate-500 mt-2">Be the first one to create a post!</p>
            <Link to="/create-post" className="mt-4 inline-block bg-blue-600 text-white font-semibold px-5 py-2 rounded-lg hover:bg-blue-700 transition">
              Create Post
            </Link>
        </div>
      )}
    </div>
  );
};

export default PostList;
